import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Service} from "../../../models/service.model";

require('./services-table-item.scss');
@Component({
  standalone: false,
  selector: 'app-services-table-item',
  templateUrl: './services-table-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicesTableItemComponent implements OnInit {

  @Input() service: Service;
  @Input() isSelected: boolean;

  @Output() toggleEvent = new EventEmitter<{ serviceId: string, event: any }>();

  constructor() {
  }

  ngOnInit() {
  }

  onToggle(event) {
    event.stopPropagation()
    this.toggleEvent.emit({serviceId: this.service.id, event: event});
  }

}
